import { createSelector } from "reselect";
import { StoreState } from "Store/Reducers";

const fetchExtensions = ({settings}: StoreState) => settings.extensions;
export const getExtensions = createSelector(fetchExtensions, ({ids}) => (ids));
export const getExtensionsById = createSelector(fetchExtensions, ({entities}) => (entities));
export const isExtensionsFetching = createSelector(fetchExtensions, ({_isFetching}) => (_isFetching));

export const getExtensionByName = createSelector(
    fetchExtensions,
    (_, name) => name,
    ({ entities, byExtension }, name) => entities?.[byExtension?.[name]]
);